export class DelegatToUpdate {  
    delegateIds!:string[];
    delegateTo!: string[];
}
